import unit from './unit';

export default function millimeter(value, decimals = 0) {
  return unit(value, 'mm', decimals);
}
